import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import timeZone from 'moment-timezone';
import 'moment/locale/zh-cn';
import moment from 'moment/moment.js';
import React from 'react';
import { Badge } from 'react-bootstrap';
import OrderAddNote from './OrderAddNote';
import { useOrderDetailViewOnly } from './OrderDetailViewOnlyContext';
import { useOrderContext } from '../../../../../providers/OrderProvider';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { normalizeOrderNotesList } from '../../../../../utils/order/orderNotesList';

const OrderNotesDetail = ({ type }) => {
	const { order } = useOrderContext();
	const viewOnly = useOrderDetailViewOnly();
	const orderNotes = normalizeOrderNotesList(order?.orderNotes);
	const isApprovalRejected = order?.approvalStatus === 'reject';

	const arrayForSort = [...orderNotes].sort((a, b) => new Date(b.create_time) - new Date(a.create_time));
	return (
		<EventModalMediaContent icon='sticky-note' heading='备注'>
			{arrayForSort.length !== 0 &&
				arrayForSort.map((item, index) => (
					<div key={index}>
						<div className='mb-1'>
							{item.type === 'create' && <Badge className='me-2'>新建</Badge>}
							{item.type === 'approval' && (
								<Badge className='me-2' bg='danger'>
									审批
								</Badge>
							)}
							{item.type === 'pay' && (
								<Badge className='me-2' bg='warning'>
									财务
								</Badge>
							)}
							{item.type === 'delivery' && (
								<Badge className='me-2' bg='warning'>
									发货
								</Badge>
							)}
							{item.type === 'accept' && (
								<Badge className='me-2' bg='info'>
									验收
								</Badge>
							)}
							{item.type === 'additional' && (
								<Badge className='me-2' bg='primary'>
									其他
								</Badge>
							)}
							<span className='fs-11 me-2 '>{timeZone.tz(moment(item?.create_time).locale('zh-cn'), 'Asia/Shanghai').format('lll')}</span>
						</div>

						<div className='mb-2'>
							<span className='me-3'>{item.user_name}：</span>
							<FontAwesomeIcon icon='fa-solid fa-quote-left' className='text-primary' />
							<span className='mx-2'>{item.note}</span>
							<FontAwesomeIcon icon='fa-solid fa-quote-right' className='text-primary' />
						</div>
					</div>
				))}
			{isApprovalRejected || viewOnly ? null : <OrderAddNote type={type} />}
		</EventModalMediaContent>
	);
};

export default OrderNotesDetail;
